module.exports = "/images/gym.svg?503afef7e0daeeb89b66c6cee21f1999";